<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1 style="padding-bottom:15px;">Dedication</h1>
<p>This book is dedicated to the people with whom I have shared my personal journey of all these years in Cambridge and to the people of the St Paul’s family, both to those who attend on a Sunday and those who do not.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?0a0b71ec